import moment from 'moment'

export default {
  methods: {
    dateDefault (date) {
      if (!date) return null
      return moment(date).format('DD.MM.YYYY')
    },
    timeDefault (date) {
      if (!date) return null
      return moment(date).format('HH:m')
    },

    dateIso (date) {
      if (!date) return null
      return moment(date).format('DD.MM.YYYY HH:mm')
    },

    dateFromUnix (date, detail = false) {
      if (!date) return null
      if (detail) {
        return moment.unix(date).format('DD.MM.YYYY HH:mm')
      } else { return moment.unix(date).format('DD.MM.YYYY') }
    }

  }
}
